import { FormEvent, useContext, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { ContextModal } from '../../../components/modules/modal/modalContext'
import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOAD_DEFAULTS,
  TABLE_OF_TABLES,
  LOAD_MODULES,
} from '../../../store/actions/actionsTypes'
import { loadDefaults } from '../../../components/modules/requests/loadDefaults'
import { vibrationFunc } from '../../../components/modules/vibrationModule'
import { Auth } from '../../../components/modules/API/Auth/auth'
import { Defaults } from '../../../components/modules/API/Defaults/defaults'
import { Invites } from '../../../components/modules/API/invites/invites'
import { instance } from '../../../components/modules/API/config'
import { UseLoginFormReturn } from './LoginForm.types'

export const useLoginForm = (): UseLoginFormReturn => {
  const [, setModal] = useContext(ContextModal)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [isInternal, setInternal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const inviteToken = location.search.split('=')[1] || null

  const showError = (value: string) => {
    setModal({ open: true, value, mood: false })
    setTimeout(() => setModal({ open: false, value: '2' }), 3000)
  }

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    if (isLoading) return
    setIsLoading(true)
    try {
      const res: any = await Auth.login({
        Login: username,
        Password: password,
        Internal: isInternal,
      } as any)

      if (res.requires2fa) {
        setIsLoading(false)
        navigate(`/2fa-verify?tempToken=${res.tempToken}`)
        return
      }

      setIsLoading(false)
      setModal({ open: true, value: ` ברוכים הבאים ${username}`, mood: true })
      setTimeout(() => setModal({ open: false, value: '2' }), 3000)
      dispatch({ type: LOGIN_SUCCESS, payload: res })

      const modules = await Defaults.getAvailableModules()
      dispatch({ type: LOAD_MODULES, payload: modules })
      await loadDefaults(res.token, LOAD_DEFAULTS, TABLE_OF_TABLES, dispatch)

      if (inviteToken) {
        const decodedToken = await Invites.addCompany({ token: inviteToken })
        localStorage.setItem('user', JSON.stringify(decodedToken))
        ;(instance as any).updateToken = decodedToken
      }
    } catch (err: any) {
      vibrationFunc('warning')
      dispatch({ type: LOGIN_FAIL })
      setIsLoading(false)
      if (err?.response?.status === 404) {
        showError('שם משתמש או סיסמא שגויים')
      } else {
        showError('משהו השתבש, נסה שוב')
      }
    }
  }

  return {
    username,
    password,
    isInternal,
    isLoading,
    inviteToken,
    setUsername,
    setPassword,
    setInternal,
    handleSubmit,
  }
}
